import { Box, Button, Flex } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FUNNEL_TYPES } from "../../funnel/utils/contants";
import { setFunnelModalConfig } from "../../funnel/FunnelModal";
import { FunnelContextArea } from "../../funnel/types";

export function LoginMenu() {
  const { t } = useTranslation();

  return (
    <Flex direction="row" pr={2} align="center">
      <Button
        id="btnNavLogin"
        background="brand.500"
        color="white"
        size="sm"
        onClick={() => {
          setFunnelModalConfig({
            type: FUNNEL_TYPES.login,
            context: {
              modalContext: FunnelContextArea.navBar,
            },
          });
        }}
      >
        {t("components.navigation.auth.login")}
      </Button>
      <Box width="8px" />
      <Button
        id="btnNavSignup"
        variant="primary"
        size="sm"
        onClick={() => {
          setFunnelModalConfig({
            type: FUNNEL_TYPES.signup,
            context: {
              modalContext: FunnelContextArea.navBar,
            },
          });
        }}
      >
        {t("components.navigation.auth.signUpItsFree")}
      </Button>
    </Flex>
  );
}
